var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cw-page',{staticClass:"car-loan__complete",attrs:{"icon":"check"}},[_c('v-row',[_c('v-col',[_c('p',{staticClass:"mb-0"},[_c('translate',[_vm._v(" You can now close your browser. ")])],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }